import { motion } from "framer-motion";
import {
  ShieldCheck, Eye, MessageSquare, Move, ClipboardList, Siren, Award, Users,
} from "lucide-react";

const TOPICS = [
  { icon: ShieldCheck, label: "Peranan & Etika Pengawal Peribadi" },
  { icon: Eye, label: "Kesedaran Situasi" },
  { icon: MessageSquare, label: "Komunikasi" },
  { icon: Move, label: "Pergerakan & Positioning Perlindungan" },
  { icon: ClipboardList, label: "Penilaian Risiko Asas" },
  { icon: Siren, label: "Prosedur Kesiapsiagaan" },
  { icon: Award, label: "Disiplin & Profesionalisme" },
  { icon: Users, label: "Kerjasama Pasukan" },
];

export function TrainingExperience() {
  return (
    <section data-testid="kursus-training" className="bg-kursus-bg py-20 sm:py-28">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.h2
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="font-anton uppercase text-3xl sm:text-4xl text-kursus-white text-center mb-12"
        >
          APA YANG AKAN ANDA <span className="text-kursus-gold">PELAJARI?</span>
        </motion.h2>

        <div className="grid sm:grid-cols-2 gap-3.5">
          {TOPICS.map((t, i) => (
            <motion.div
              key={t.label}
              initial={{ opacity: 0, x: -16 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.06 }}
              data-testid={`kursus-topic-${i}`}
              className="flex items-center gap-4 bg-kursus-card border-l-2 border-kursus-gold rounded-r-lg px-5 py-4 hover:bg-kursus-card/70 transition-colors"
            >
              <t.icon className="w-5 h-5 text-kursus-gold shrink-0" />
              <span className="font-oswald text-sm sm:text-base text-kursus-white/90">{t.label}</span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
